





















import { Component, Vue } from 'vue-property-decorator';

interface ReportsNavItem {
  routeName: string;
  label: string;
  icon: string;
}

@Component({})
export default class ReportsNavComponent extends Vue {
  public items: ReportsNavItem[] = [
    { routeName: 'reports_overview_view', label: 'Übersicht', icon: 'mdi-view-dashboard-outline' },
    { routeName: 'reports_labels_view', label: 'Antriebstypen', icon: 'mdi-tag-text-outline' },
    { routeName: 'reports_projects_view', label: 'Projekte', icon: 'mdi-folder-outline' },
    { routeName: 'reports_technical_view', label: 'Antriebe', icon: 'mdi-engine-outline' },
    { routeName: 'reports_customers_view', label: 'Kunden', icon: 'mdi-account-group-outline' }
  ];

  public isActive(routeName: string): boolean {
    return this.$route.name === routeName;
  }
}
